import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import * as echarts from "echarts";
import { getGuanqiaData } from '@/api/data';
import DataOptions from "../../../components/timeList/dataOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    VxeTable: VxeTable
  },
  data: function data() {
    return {
      tableData: {},
      dateAry: [],
      serverInfo: [],
      dateInfo: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        title: "日期",
        field: "date_str"
      }, {
        title: "活跃角色",
        field: "activity_role"
      }, {
        title: "活跃角色开始次数",
        field: "activity_start_av"
      }, {
        title: "活跃角色通关次数",
        field: "activity_win_av"
      }, {
        title: "新增角色",
        field: "new_role"
      }, {
        title: "新增角色开始次数",
        field: "new_start_av"
      }, {
        title: "新增角色通关次数",
        field: "new_win_av"
      }, {
        title: "老角色",
        field: "old_role"
      }, {
        title: "老角色开始次数",
        field: "old_start_av"
      }, {
        title: "老角色通关次数",
        field: "old_win_av"
      }]
    };
  },
  methods: {
    initStartChart: function initStartChart() {
      var myChart = echarts.init(this.$refs.startChart);
      var activityAry = [];
      var newAry = [];
      var oldAry = [];
      var option = {
        xAxis: {
          type: 'category',
          data: this.dateAry
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['活跃角色', '新角色', '老角色']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '活跃角色',
          data: activityAry,
          type: 'line'
        }, {
          name: '新角色',
          data: newAry,
          type: 'line'
        }, {
          name: '老角色',
          data: oldAry,
          type: 'line'
        }]
      };
      var _iterator = _createForOfIteratorHelper(this.tableData.list.slice().reverse()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var data = _step.value;
          activityAry.push(data.activity_start_av);
          newAry.push(data.new_start_av);
          oldAry.push(data.old_start_av);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      myChart.setOption(option);
    },
    initWinChart: function initWinChart() {
      var myChart = echarts.init(this.$refs.winChart);
      var activityAry = [];
      var newAry = [];
      var oldAry = [];
      var option = {
        xAxis: {
          type: 'category',
          data: this.dateAry
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['活跃角色', '新角色', '老角色']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '活跃角色',
          data: activityAry,
          type: 'line'
        }, {
          name: '新角色',
          data: newAry,
          type: 'line'
        }, {
          name: '老角色',
          data: oldAry,
          type: 'line'
        }]
      };
      var _iterator2 = _createForOfIteratorHelper(this.tableData.list.slice().reverse()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var data = _step2.value;
          activityAry.push(data.activity_win_av);
          newAry.push(data.new_win_av);
          oldAry.push(data.old_win_av);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      myChart.setOption(option);
    },
    initDateAry: function initDateAry() {
      var _this = this;
      this.dateAry.length = 0;
      this.tableData.list.slice().reverse().forEach(function (item) {
        if (item.date_str) {
          _this.dateAry.push(item.date_str);
        }
      });
    },
    onSearchBtn: function onSearchBtn() {
      var _this2 = this;
      var searchInfo = {
        sdate: this.dateInfo[0],
        edate: this.dateInfo[1],
        server_id: this.serverInfo
      };
      searchInfo.server_id = this.serverInfo;
      var _iterator3 = _createForOfIteratorHelper(searchInfo.server_id),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var serverId = _step3.value;
          if (serverId == '0') {
            searchInfo.server_id = [];
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      getGuanqiaData(searchInfo).then(function (res) {
        _this2.tableData = res.data;
        _this2.initDateAry();
        _this2.initStartChart();
        _this2.initWinChart();
      });
    },
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    }
  },
  mounted: function mounted() {
    this.footDataToFirst();
    this.onSearchBtn();
  }
};